import { TextField, TextAreaField } from "@/components/forms";
import type { ApplicationFormData } from "./types";
import { APPLICATION_LIMITS, type FieldErrors, type SummaryField } from "./validation";

interface SummaryStepProps {
  formData: ApplicationFormData;
  onChange: (field: keyof ApplicationFormData, value: string) => void;
  /** Messages to show now, per field (see `visibleErrors`). */
  errors?: FieldErrors<SummaryField>;
}

export function SummaryStep({ formData, onChange, errors = {} }: SummaryStepProps) {
  return (
    <div className="space-y-4">
      <TextField
        id="headline"
        label="Headline"
        value={formData.headline}
        onChange={(v) => onChange("headline", v)}
        error={errors.headline}
        placeholder="e.g. Enterprise Operations Leader"
        hint="A one-line summary of who you are professionally."
      />
      <TextAreaField
        id="professionalSummary"
        label="Professional summary"
        required
        value={formData.professionalSummary}
        onChange={(v) => onChange("professionalSummary", v)}
        error={errors.professionalSummary}
        countLimit={APPLICATION_LIMITS.PROFESSIONAL_SUMMARY_MAX}
        placeholder="Tailor a short pitch for this role. Lead with measurable outcomes and the impact you want to make here."
        rows={6}
      />
      <TextField
        id="totalExperienceYears"
        type="number"
        min={APPLICATION_LIMITS.EXPERIENCE_YEARS_MIN}
        max={APPLICATION_LIMITS.EXPERIENCE_YEARS_MAX}
        label="Total years of experience"
        value={formData.totalExperienceYears}
        onChange={(v) => onChange("totalExperienceYears", v)}
        error={errors.totalExperienceYears}
        placeholder="8"
        containerClassName="max-w-[200px]"
      />
    </div>
  );
}
